import { render, staticRenderFns } from "./DashboardEquipamiento.vue?vue&type=template&id=cf3b0b48&scoped=true"
import script from "./DashboardEquipamiento.vue?vue&type=script&lang=js"
export * from "./DashboardEquipamiento.vue?vue&type=script&lang=js"
import style0 from "./DashboardEquipamiento.vue?vue&type=style&index=0&id=cf3b0b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3b0b48",
  null
  
)

export default component.exports